import React, { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { Path, RouteName } from '@const/paths'
import { Direction } from '@const/consts';

import { useAppSelector } from '@hooks/redux'
import { createUrl } from '@utils/utils'

const RedirectToStartPage: FC = () => {
  const { pathname, search } = useLocation()
  const currentLocation = `${pathname}${search}`
  const {
    isAuthenticated,
    profile: {
      boxOguid
    },
    settings
  } = useAppSelector((state ) => state.user)
  const boxes = useAppSelector((state) => state.boxes.boxes)

  if (!isAuthenticated) {
    return (
      <Navigate
        replace
        to={{
          pathname: RouteName.SIGN_IN,
        }}
        state={{ from: currentLocation }}
      />
    )
  }

  if (!boxOguid) return null

  const availableBoxOguids = new Set([boxOguid, ...boxes.map((box) => box.oguid)])
  const lastOpenedBoxOguid = settings.lastOpenedBoxOguid
  const startBoxOguid = lastOpenedBoxOguid && availableBoxOguids.has(lastOpenedBoxOguid)
    ? lastOpenedBoxOguid
    : boxOguid

  const section = Path.ENVELOPES_BOX_OGUID
    .replace(':boxOguid', startBoxOguid)
    .replace(':directionOrFolder', Direction.INCOMING)

  return <Navigate to={createUrl(section)} />
}

export default RedirectToStartPage
